import Axios from "axios";

export const common = {
  namespaced: true,
  state: {
    lang: "ja", // 言語
    device: null, // 使用端末
    appVersion: null, // アプリバージョン
    isLogin: false, //ログイン状態
    idToken: null, // MaaS Japan IDトークン
    accessToken: null, // MaaS Japanアクセストークン
    CreditCard: null, // クレジットカード登録有無
    isApiPending: false, // token切れ時の処理用
    isReloadComponent: null, // trigger refresh current main component if true
  },
  getters: {
    lang(state) {
      return state.lang;
    },
    device(state) {
      return state.device;
    },
    appVersion(state) {
      return state.appVersion;
    },
    isLogin(state) {
      return state.isLogin;
    },
    idToken(state) {
      return state.idToken;
    },
    accessToken(state) {
      return state.accessToken;
    },
    APIRequestHeader(state) {
      return {
        params: { language: state.lang },
        headers: {
          Authorization: state.idToken,
          "Access-Token": state.accessToken,
        },
      };
    },
    CreditCard(state) {
      return state.CreditCard;
    },
    isApiPending(state) {
      return state.isApiPending;
    },
    isReloadComponent(state) {
      return state.isReloadComponent;
    },
  },
  mutations: {
    setLang(state, lang) {
      state.lang = lang;
    },
    setDevice(state, device) {
      state.device = device;
    },
    setAppVersion(state, version) {
      state.appVersion = version;
    },
    setTokens(state, Tokens) {
      state.idToken = Tokens.idToken;
      state.accessToken = Tokens.accessToken;
      if (Tokens.accessToken.length > 0) {
        state.isLogin = true;
      }
    },
    setCreditCard(state, CreditCard) {
      state.CreditCard = CreditCard;
    },
    setIsApiPending(state, isApiPending) {
      state.isApiPending = isApiPending;
    },
    setIsReloadComponent(state, isReloadComponent) {
      state.isReloadComponent = isReloadComponent;
    },
  },
  actions: {
    async getRequest(_context, { path, bodyParams }) {
      return await Axios.get(
        `${process.env.VUE_APP_BFF_API_URL}${path}`,
        _context.rootGetters["common/APIRequestHeader"],
        {
          params: bodyParams,
        }
      );
    },

    async postRequest(_context, { path, bodyParams }) {
      return await Axios.post(
        `${process.env.VUE_APP_BFF_API_URL}${path}`,
        bodyParams,
        _context.rootGetters["common/APIRequestHeader"],
        {}
      );
    },

    async putRequest(_context, { path, bodyParams }) {
      await Axios.put(
        `${process.env.VUE_APP_BFF_API_URL}${path}`,
        bodyParams,
        _context.rootGetters["common/APIRequestHeader"]
      );
    },

    async deleteRequest(_context, { path, bodyParams }) {
      try {
        await Axios.delete(
          `${process.env.VUE_APP_BFF_API_URL}${path}`,
          _context.rootGetters["common/APIRequestHeader"],
          bodyParams
        );
      } catch (err) {
        throw new Error("UnhandlableError");
      }
    },

    async getCardInfo(context) {
      var params = {};
      const resp = await context.dispatch("getRequest", {
        path: `card-info`,
        bodyParams: params,
      });
      context.commit("setCreditCard", resp.data);
    },

    async postLog(context, { apiParams }) {
      await context.dispatch(
        "common/postRequest",
        {
          path: `debug-logs`,
          bodyParams: apiParams,
        },
        { root: true }
      );
    },
  },
};
